/* eslint-disable class-methods-use-this */
import { ChatMode } from '../store';
import { BaseMessageSender } from './BaseMessageSender';
import ChatbotMessageSender from './ChatbotMessageSender';
import LiveChatMessageSender from './LiveChatMessageSender';

export class MessageSenderFactory {
	create(chatMode: ChatMode): BaseMessageSender {
		switch (chatMode) {
			case ChatMode.LiveChat:
				return new LiveChatMessageSender();
			default:
				return new ChatbotMessageSender();
		}
	}
}

export default new MessageSenderFactory();
